import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawerOpen: {
    bol: false,
    open: false,
  },
 permitStatus:null,
 isPermitShift:false,
 hazardSheet:0
};

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    drawer: (state, actions) => {
      state.drawerOpen = actions.payload;
    },
    permitStatus:(state,actions)=>{
      state.permitStatus=actions.payload.permitStatus
      state.isPermitShift=actions.payload.isPermitShift
    },
    hazardSheet: (state, actions) => {
      state.hazardSheet = actions.payload;
    },
   
  },
});

export const {
  drawer,
  permitStatus,
  hazardSheet
} = dataSlice.actions;

export const dataReducers = dataSlice.reducer;




